
export enum DriverTurnTypeCd {
	CITY_TURN = 'CityTurn',
	DOUBLE_TURN = 'DoubleTurn'}
